export default Object.freeze({
  //PROMOTION_DISCOUNT_ADDFORM
  DISCOUNT: '추가할인',
  REGISTER: '등록',
  MODIFY: '수정',
  BASIC_INFO: '기본정보',
  MALL: '쇼핑몰',
  NAME: '추가할인명',
  NAME_PLACEHOLDER: '추가할인명 입력',
  REASON: '추가할인 사유',
  REASON_PLACEHOLDER: '추가할인 사유 입력',
  PERIOD: '할인 기간',
  DISCOUNT_STATUS: '할인 상태',
  DISCOUNT_END: '할인종료',

  //추가할인 회원 대상 설정
  TARGET_SET: '회원 대상 설정',
  TARGET_MEMBER: '할인적용 회원',
  ALL_MEMBERS: '전체회원',
  MEMBER_SELECTION: '회원선택',
  EXCEPT_NON_MEMBER: '비회원 제외',
  MEMBER_LEVEL_GROUP: '회원등급/그룹',
  POPUP_MEMBER_SELECT: '회원등급/그룹 선택 팝업',
  MEMBER_DETAIL: '회원 대상 상세',
  TARGET_CHANGE: '할인대상변경',
  CANCEL: '취소',
  ALL: '전체',
  DISCOUNT_READY: '진행대기',
  DISCOUNT_ING: '할인중',
  DISCOUNT_EXPIRED: '기간만료',

  // 추가할인 대상설정
  PRODUCT_TARGET_INFO: '추가할인 대상설정',
  PRODUCT_TARGET_RADIO_TITLE: '할인 대상',
  PRODUCT_TARGET_RADIO_ALL_PRODUCT: '전상품',
  PRODUCT_TARGET_RADIO_PRODUCT: '개별상품',
  PRODUCT_EXCLUDE_TARGET_RADIO_TITLE: '할인 대상 제외 설정',
  PRODUCT_EXCLUDE_TARGET_RADIO_IS_EXCLUDE_FALSE: '설정안함',
  PRODUCT_EXCLUDE_TARGET_RADIO_IS_EXCLUDE_TRUE: '설정',

  //테이블(API 응답 필드명과 상동)
  DELETE: '삭제',
  MALL_PRODUCT_NO: '상품번호',
  PRODUCT_NAME: '상품명',
  PRODUCT_MANAGEMENT_CD: '상품관리코드',
  SALE_METHOD_TYPE: '판매방식',
  SALE_METHOD_TYPE_PURCHASE: '사입',
  SALE_METHOD_TYPE_CONSIGNMENT: '위탁',
  PARTNER_NAME: '파트너명',
  COMMISSION_RATE: '수수료율',
  SUPPLY_PRICE: '공급가',
  PURCHASE_PRICE: '매입가',
  APPLY_DISCOUNT_SALE_PRICE: '할인적용가',
  ADDITIONAL_DISCOUNT_AMOUNT: '추가할인',
  APPLY_ADDITIONAL_DISCOUNT_SALE_PRICE: '추가할인적용가',
  REVERS_MARGIN: '역마진',
  PRODUCT_TITLE: '추가할인 대상 상품',
  PRODUCT_TABLE_TITLE: '추가할인 대상 상품 안내',
  PRODUCT_TABLE_DESCRIPTION: '추가할인 대상 상품 리스트입니다. 단, 아래에 해당 될 경우 추가할인 적용은 실패 됩니다.',
  PRODUCT_TABLE_TIPS_PARTNER_DISAGREE: '파트너 미동의 : 파트너사 프로모션 동의 안 함인 경우 (파트너센터 기초정보관리에서 설정변경 가능)',
  PRODUCT_TABLE_TIPS_PROMOTION_IMPOSSIBLE: '프로모션 불가상품 : 상품의 프로모션 설정 값 중 \'추가할인\'이 선택되지 않은 경우 (상품수정에서 설정변경 가능)',
  PRODUCT_TABLE_TIPS_AMOUNT_CONDITION_IMPOSSIBLE: '금액조건 불가 : 상품이 할인 금액조건에 맞지 않는 가격일 경우',
  PRODUCT_TABLE_TIPS_REGISTER_IMPOSSIBLE: '등록불가 상품상태 : 상품 상태가 판매종료, 판매금지, 삭제요청, 등록대기인 경우',
  EXCLUDE_TITLE: '추가할인 제외 대상 상품',
  DISCOUNT_REGISTER: '추가할인 등록',
  SAVE_CHANGES: '변경사항 저장',
  EXCLUDE_TABLE_TITLE: '추가할인 제외 대상 상품 안내',
  EXCLUDE_TABLE_TIPS_EXCLUDE_TARGET: '추가할인 제외 대상 상품은 해당 ‘추가할인’ 이 적용되지 않습니다.',
  EXCLUDE_TABLE_TIPS_DIRECT_REMOVE: '추가할인 제외 대상 상품 중 ‘직접 삭제’ 한 상품은, ‘추가할인 대상 상품’ 으로 설정됩니다.',
  EXCLUDE_TABLE_TIPS_DISCOUNT_END_TARGET: '할인종료된 추가할인의 추가할인 제외 대상 상품 설정은 불가합니다.',
  DELETE_TITLE: '추가할인 삭제 상품',
  DELETE_TABLE_TITLE: '추가할인 삭제 상품 안내',
  DELETE_TABLE_TIPS_DELTE_TARGET: '파트너미동의/프로모션불가상품/금액조건불가/등록불가 상품 상태인 경우 추가할인에서 제외처리 됩니다.(해당 목록에 노출되지 않음)',
  DELETE_TABLE_TIPS_DUPLICATE_TARGET: '추가할인 대상이 전상품일때 중복된 상품으로 추가할인이 등록된 경우 추가할인에서 제외처리되고 해당 목록에 노출됩니다.',
  DELETE_CONFIRM_MESSAGE: '선택하신 추가할인 제외 상품 삭제 시, 추가할인 대상 상품으로 설정됩니다. 삭제하시겠습니까?',
  RESET_CONFIRM_MESSAGE: '추가할인 등록 정보를 변경하시면 설정한 상품리스트가 초기화됩니다.\n 계속 진행하시겠습니까?',
  NOT_CHECK_PRODUCT: '삭제할 추가 할인 대상 상품을 선택해 주세요.',
  NOT_CHECK_EXCLUDE: '삭제할 추가 할인 제외 상품을 선택해 주세요.',
  PRODUCT_EMPTY_MESSAGE: '등록된 추가할인 대상 상품이 없습니다.',
  EXCLUDE_EMPTY_MESSAGE: '등록된 추가할인 제외 대상 상품이 없습니다.',
  DELETE_EMPTY_MESSAGE: '등록된 추가할인 삭제 상품이 없습니다.',

  DELETE_REASON: '삭제사유',
  ADD_DATE: '추가일',
  DELETE_DATE: '삭제일',

  PARTNER_DISAGREE: '파트너미동의',
  PROMOTION_NOT_ALLOWED: '프로모션불가상품',
  PRICE_MISMATCH: '금액조건불가',
  ANOTHER_DISCOUNT: '다른 추가할인 설정',
  REGISTER_NOT_ALLOWED: '등록불가상태',
  END_DISCOUNT: '할인 종료',
  DUPLICATE: '중복 상품번호',

  // 엑셀
  EXCEL_APPLICABLE: '추가할인적용가',
  EXCEL_APPLY_DISCOUNT_SALE_PRICE: '판매가/할인적용가',

  CANCEL_MESSAGE: '변경한 추가할인 대상이 취소되었습니다.',
  REGISTER_MESSAGE: '신규 추가할인이 정상 등록 되었습니다.',
  MODIFY_MESSAGE: '수정되었습니다.',

  //  추가할인 금액 설정
  AMOUNT_INFO: '금액 설정',
  MIN_LIMIT: '최소 기준금액',
  MAX_LIMIT: '최대 기준금액',
  NO_LIMIT: '제한 없음',
  MORE_THAN_WON: '원 이상',
  LESS_THAN_WON: '원 이하',
  DISCOUNT_AMOUNT: '할인 금액',
  FIXED: '정액',
  CONSTANT: '정률',
  WON_DISCOUNT: '원 할인',
  MAX: '최대',
  COST_SHARING: '비용분담 설정',
  SERVICE_SHARE: '쇼핑몰 부담',
  PARTNER_SHARE: '파트너 부담',

  // error message
  ERR_MINSALE_NULL: '최소 기준금액을 입력해 주세요.',
  ERR_MAXSALE_NULL: '최대 기준금액을 입력해 주세요.',
  ERR_DISCOUNT_NULL: '할인금액을 입력해 주세요.',
  ERR_PERCENT_NULL: '할인률은 1 ~ 99 사이로 입력해 주세요.',
  ERR_MAXDISCOUNT_NULL: '최대 할인금액을 입력해 주세요.',
  ERR_LESSTHAN: '최대 할인금액을 10보다 작게 입력하실 수 없습니다. 할인금액을 다시 확인해 주세요.',
  ERR_UNIT: '할인금액을 10 단위로 입력하실 수 있습니다.',
  ERR_INPUT_FORMAT: '입력형식이 잘못되었습니다.',
  ERR_AMOUNT: '금액기준을 다시 확인해주세요.',
  ERR_DISCOUNT_NAME: '추가할인명을 입력해 주세요.',
  ERR_MEMBER_TARGET: '회원등급/그룹을 설정해주세요.',
  ERR_AMOUNT_EMPTY: '입력 항목을 확인해 주세요.',
  ERR_PERIOD: '전상품으로 등록한 추가할인의 기간이 중복됩니다.\n확인해주시기 바랍니다.',
  ERR_EMPTY_TARGET: '추가할인 대상 상품을 등록해주세요.',
  ERR_EMPTY_EXCLUDE: '추가할인 제외 대상 상품을 등록해주세요.',

  // confirm message
  CONFIRM_SAVE: '변경된 내용을 저장하시겠습니까?',
  CONFIRM_REGISTER: '추가할인 등록을 완료 하시겠습니까?',
  CONFIRM_DISCOUNT_END: '추가할인을 종료하시겠습니까?',
  CONFIRM_CANCEL_REGISTER: '등록을 취소하고 목록으로 이동하시겠습니까?\n입력하신 내용은 저장되지 않습니다.',
  CONFIRM_CANCEL_MODIFY: '수정을 취소하시겠습니까?\n수정하신 내용은 저장되지 않습니다.',
  DISCOUNT_END_MESSAGE: '추가할인이 종료되었습니다',
  DISCOUNT_END_FAIL_MESSAGE: '추가할인을 종료에 실패했습니다.',
  CONFIRM_RESET: '추가할인 등록 정보를 변경하시면 설정한 상품리스트가 초기화됩니다.\n 계속 진행하시겠습니까?',
  REMOVE_PRODUCT_CONFIRM: '선택하신 추가할인 제외 상품 삭제 시, 추가할인 대상 상품으로 설정됩니다.\n 삭제 하시겠습니까?',


  // layer popup
  LP_TITLE: '추가할인 삭제 상품 안내',
  LP_CONTENT_1: '파트너미동의/프로모션불가상품/금액조건불가/등록불가 상품 상태인 경우 추가할인에서 제외처리 됩니다.(해당 목록에 노출되지 않음)',
  LP_CONTENT_2: '추가할인 대상이 전상품일때 중복된 상품으로 추가할인이 등록된 경우 추가할인에서 제외처리되고 해당 목록에 노출됩니다.'
});
